import { useRef, useState } from "react";
import DncIvr from "../assets/Audio/DNC-IVR.mp3";

import L1 from "../assets/Audio/Left/L1_Hello1.mp3";
import L2 from "../assets/Audio/Left/L2_HelloCanYouHearMe2.mp3";
import L3 from "../assets/Audio/Left/L3_Intro1.mp3";
import L4 from "../assets/Audio/Left/L4_Intro2.mp3";
import L5 from "../assets/Audio/Left/L5_FullName_Becky.mp3";
import L6 from "../assets/Audio/Left/L6_CompanyName.mp3";
import L7 from "../assets/Audio/Left/L7_ImDoingGreatThankYouSoMuchForAsking.mp3";
import L8 from "../assets/Audio/Left/L8_ImFineThankyou.mp3";
import L9 from "../assets/Audio/Left/L9_ImGladToHearThat.mp3";
import L10 from "../assets/Audio/Left/L10_Laugh.mp3";
import L11 from "../assets/Audio/Left/L11_Great.mp3";
import L12 from "../assets/Audio/Left/L12_Yes.mp3";
import L13 from "../assets/Audio/Left/L13_Yes Maam.mp3";
import L14 from "../assets/Audio/Left/L14_Yes sir.mp3";
import L15 from "../assets/Audio/Left/L15_Are you there.mp3";
import L16 from "../assets/Audio/Left/L16_Can you hear me now.mp3";
import L17 from "../assets/Audio/Left/L17_THANKYOU.mp3";

import L18 from "../assets/Audio/Left/intro-sophia.mp3";
import L19 from "../assets/Audio/Left/intro-emma.mp3";
import L20 from "../assets/Audio/Left/intro-jasmine.mp3";
import L21 from "../assets/Audio/Left/age-above-50.mp3";

import M1 from "../assets/Audio/Middle/M1_HOLD1.mp3";
import M2 from "../assets/Audio/Middle/M2_HOLD2.mp3";
import M3 from "../assets/Audio/Middle/M3_WEATHER.mp3";
import M4 from "../assets/Audio/Middle/M4_Can you repeat.mp3";
import M5 from "../assets/Audio/Middle/M5_Reason 1.mp3";
import M6 from "../assets/Audio/Middle/M6_Reason 2.mp3";
import M7 from "../assets/Audio/Middle/M7_Age1.mp3";
import M8 from "../assets/Audio/Middle/M8_Age2.mp3";
import M9 from "../assets/Audio/Middle/M9_AgeRebut.mp3";
import M10 from "../assets/Audio/Middle/M10_Decision maker1.mp3";
import M11 from "../assets/Audio/Middle/M11_Decision Maker2.mp3";
import M12 from "../assets/Audio/Middle/M12_BENEFICARY.mp3";
import M13 from "../assets/Audio/Middle/M13_Health issue.mp3";
import M14 from "../assets/Audio/Middle/M14_CHECKING OR SAVING ACCOUNT 2.mp3";
import M15 from "../assets/Audio/Middle/M15_NAME.mp3";
import M16 from "../assets/Audio/Middle/M16_Transfer line 1.mp3";
import M17 from "../assets/Audio/Middle/M17_Transfer line 2.mp3";
import M18 from "../assets/Audio/Middle/M18_Optin1.mp3";
import M19 from "../assets/Audio/Middle/M19_Optin2.mp3";
import M20 from "../assets/Audio/Middle/M20_NOT INTERESTED.mp3";
import M21 from "../assets/Audio/Middle/M21_No.mp3";
import M22 from "../assets/Audio/Middle/M22_Reason 3.mp3";

import R1 from "../assets/Audio/Right/R1_NOT RIGHT NOW.mp3";
import R2 from "../assets/Audio/Right/R2_BUSY1.mp3";
import R3 from "../assets/Audio/Right/R3_BUSY 2.mp3";
import R4 from "../assets/Audio/Right/R4_ALREADY HAVE INSURANCE 1.mp3";
import R5 from "../assets/Audio/Right/R5_How did you get my information.mp3";
import R6 from "../assets/Audio/Right/R6_LOCATED.mp3";
import R7 from "../assets/Audio/Right/R7_ALREADY HAVE INSURANCE 2.mp3";
import R8 from "../assets/Audio/Right/R8_What is final Expense Insurance.mp3";
import R9 from "../assets/Audio/Right/R9_How much will it cost.mp3";
import R10 from "../assets/Audio/Right/R10_REAL 1.mp3";
import R11 from "../assets/Audio/Right/R11_REAL 2.mp3";
import R12 from "../assets/Audio/Right/R12_RESCUE.mp3";
import R13 from "../assets/Audio/Right/R13_DNC.mp3";
import R14 from "../assets/Audio/Right/R14_QUALIFY FOR DISCOUNT.mp3";
import R15 from "../assets/Audio/Right/R15_VERIFIER BUSY.mp3";
import R16 from "../assets/Audio/Right/R16_Cost 1.mp3";
import R17 from "../assets/Audio/Right/R17_Affordability issue.mp3";
import R18 from "../assets/Audio/Right/R18_WHAT IS THIS CALL ABOUT.mp3";
import R19 from "../assets/Audio/Right/R19_EMAIL.mp3";
import R20 from "../assets/Audio/Right/R20_CALLED BRFORE.mp3";
import R21 from "../assets/Audio/Right/R21_Okay.mp3";

const Avatar = () => {
  const [audio, setAudio] = useState();
  let audioPlayerRef = useRef();

  function PlayAudio(newAudio) {
    if (newAudio === audio) {
      audioPlayerRef.current.pause();
      audioPlayerRef.current.currentTime = 0;
      audioPlayerRef.current.play();
    } else {
      setAudio(newAudio);
    }
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "felx",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <button
          className="middle-button"
          style={{ width: "25%" }}
          onClick={() => {
            PlayAudio(DncIvr);
          }}
        >
          DNC IVR
        </button>

        <audio
          style={{ alignSelf: "center" }}
          controls
          autoPlay
          preload="auto"
          src={audio}
          ref={audioPlayerRef}
        >
          Your browser does not support the audio element.
        </audio>
      </div>
      <audio src={DncIvr} type="audio/mpeg" preload="auto"></audio>
      <audio src={L1} type="audio/mpeg" preload="auto"></audio>
      <audio src={L2} type="audio/mpeg" preload="auto"></audio>
      <audio src={L3} type="audio/mpeg" preload="auto"></audio>
      <audio src={L4} type="audio/mpeg" preload="auto"></audio>
      <audio src={L5} type="audio/mpeg" preload="auto"></audio>
      <audio src={L6} type="audio/mpeg" preload="auto"></audio>
      <audio src={L7} type="audio/mpeg" preload="auto"></audio>
      <audio src={L8} type="audio/mpeg" preload="auto"></audio>
      <audio src={L9} type="audio/mpeg" preload="auto"></audio>
      <audio src={L10} type="audio/mpeg" preload="auto"></audio>
      <audio src={L11} type="audio/mpeg" preload="auto"></audio>
      <audio src={L12} type="audio/mpeg" preload="auto"></audio>
      <audio src={L13} type="audio/mpeg" preload="auto"></audio>
      <audio src={L14} type="audio/mpeg" preload="auto"></audio>
      <audio src={L15} type="audio/mpeg" preload="auto"></audio>
      <audio src={L16} type="audio/mpeg" preload="auto"></audio>
      <audio src={L17} type="audio/mpeg" preload="auto"></audio>

      <audio src={L18} type="audio/mpeg" preload="auto"></audio>
      <audio src={L19} type="audio/mpeg" preload="auto"></audio>
      <audio src={L20} type="audio/mpeg" preload="auto"></audio>
      <audio src={L21} type="audio/mpeg" preload="auto"></audio>

      <audio src={M1} type="audio/mpeg" preload="auto"></audio>
      <audio src={M2} type="audio/mpeg" preload="auto"></audio>
      <audio src={M3} type="audio/mpeg" preload="auto"></audio>
      <audio src={M4} type="audio/mpeg" preload="auto"></audio>
      <audio src={M5} type="audio/mpeg" preload="auto"></audio>
      <audio src={M6} type="audio/mpeg" preload="auto"></audio>
      <audio src={M7} type="audio/mpeg" preload="auto"></audio>
      <audio src={M8} type="audio/mpeg" preload="auto"></audio>
      <audio src={M9} type="audio/mpeg" preload="auto"></audio>
      <audio src={M10} type="audio/mpeg" preload="auto"></audio>
      <audio src={M11} type="audio/mpeg" preload="auto"></audio>
      <audio src={M12} type="audio/mpeg" preload="auto"></audio>
      <audio src={M13} type="audio/mpeg" preload="auto"></audio>
      <audio src={M14} type="audio/mpeg" preload="auto"></audio>
      <audio src={M15} type="audio/mpeg" preload="auto"></audio>
      <audio src={M16} type="audio/mpeg" preload="auto"></audio>
      <audio src={M17} type="audio/mpeg" preload="auto"></audio>
      <audio src={M18} type="audio/mpeg" preload="auto"></audio>
      <audio src={M19} type="audio/mpeg" preload="auto"></audio>
      <audio src={M20} type="audio/mpeg" preload="auto"></audio>
      <audio src={M21} type="audio/mpeg" preload="auto"></audio>
      <audio src={M22} type="audio/mpeg" preload="auto"></audio>

      <audio src={R1} type="audio/mpeg" preload="auto"></audio>
      <audio src={R2} type="audio/mpeg" preload="auto"></audio>
      <audio src={R3} type="audio/mpeg" preload="auto"></audio>
      <audio src={R4} type="audio/mpeg" preload="auto"></audio>
      <audio src={R5} type="audio/mpeg" preload="auto"></audio>
      <audio src={R6} type="audio/mpeg" preload="auto"></audio>
      <audio src={R7} type="audio/mpeg" preload="auto"></audio>
      <audio src={R8} type="audio/mpeg" preload="auto"></audio>
      <audio src={R9} type="audio/mpeg" preload="auto"></audio>
      <audio src={R10} type="audio/mpeg" preload="auto"></audio>
      <audio src={R11} type="audio/mpeg" preload="auto"></audio>
      <audio src={R12} type="audio/mpeg" preload="auto"></audio>
      <audio src={R13} type="audio/mpeg" preload="auto"></audio>
      <audio src={R14} type="audio/mpeg" preload="auto"></audio>
      <audio src={R15} type="audio/mpeg" preload="auto"></audio>
      <audio src={R16} type="audio/mpeg" preload="auto"></audio>
      <audio src={R17} type="audio/mpeg" preload="auto"></audio>
      <audio src={R18} type="audio/mpeg" preload="auto"></audio>
      <audio src={R19} type="audio/mpeg" preload="auto"></audio>
      <audio src={R20} type="audio/mpeg" preload="auto"></audio>
      <audio src={R21} type="audio/mpeg" preload="auto"></audio>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          width: "100%",
          height: "90%",
          overflow: "auto",
        }}
      >
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L1);
          }}
        >
          Hello 1
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L2);
          }}
        >
          Hello 2
        </button>
        {/* <button
          className="left-button"
          onClick={() => {
            PlayAudio(L3);
          }}
        >
          Intro 1
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L4);
          }}
        >
          Intro 2
        </button> */}
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L18);
          }}
        >
          Intro Sophia
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L19);
          }}
        >
          Intro Emma
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L20);
          }}
        >
          Intro Jasmine
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L21);
          }}
        >
          Age Above 50
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M5);
          }}
        >
          Reason 1
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M6);
          }}
        >
          Reason 2
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M22);
          }}
        >
          Reason 3
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M18);
          }}
        >
          Optin 1
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M19);
          }}
        >
          Optin 2
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M20);
          }}
        >
          Not Interested
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(R4);
          }}
        >
          Already have insurance 1
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(R7);
          }}
        >
          Already have insurance 2
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(R1);
          }}
        >
          Not Right Now
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M7);
          }}
        >
          Age 1
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M8);
          }}
        >
          Age 2
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M9);
          }}
        >
          Age Rebut
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M10);
          }}
        >
          Decision Maker 1
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M11);
          }}
        >
          Decision Maker 2
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M12);
          }}
        >
          Beneficiary
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M16);
          }}
        >
          Transfer Line 1
        </button>
        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M17);
          }}
        >
          Transfer Line 2
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M14);
          }}
        >
          Checking OR Saving
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(M13);
          }}
        >
          Health Issue
        </button>

        <button
          className="left-button"
          onClick={() => {
            PlayAudio(L5);
          }}
        >
          Full Name
        </button>

        {/* <button
          className="middle-button"
          onClick={() => {
            PlayAudio(R18);
          }}
        >
          Busy 1
        </button> */}
        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(R3);
          }}
        >
          Busy
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(R15);
          }}
        >
          Verifier Busy
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(R12);
          }}
        >
          Rescue
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(R9);
          }}
        >
          How much will it cost?
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(R18);
          }}
        >
          What is this call about?
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L6);
          }}
        >
          Company Name
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L7);
          }}
        >
          Thankyou for asking
        </button>
        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L8);
          }}
        >
          Fine Thankyou
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(M15);
          }}
        >
          Name
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L15);
          }}
        >
          Are you there?
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L13);
          }}
        >
          Yes Ma'am
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L14);
          }}
        >
          Yes Sir
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L16);
          }}
        >
          Can you hear me?
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L12);
          }}
        >
          Yes
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(M21);
          }}
        >
          No
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(R21);
          }}
        >
          Okay
        </button>
        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L11);
          }}
        >
          Great
        </button>
        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L10);
          }}
        >
          Laugh
        </button>
        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L9);
          }}
        >
          Glad to hear!
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(L17);
          }}
        >
          Thank you
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(M1);
          }}
        >
          Hold 1
        </button>
        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(M2);
          }}
        >
          Hold 2
        </button>

        <button
          className="middle-button"
          onClick={() => {
            PlayAudio(M4);
          }}
        >
          Can you repeat?
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R10);
          }}
        >
          Real 1
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R11);
          }}
        >
          Real 2
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R16);
          }}
        >
          Cost 1
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R14);
          }}
        >
          Qualify for discount
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R8);
          }}
        >
          What is final expense insurance?
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R6);
          }}
        >
          Located
          {/* Best Time To Callback */}
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R5);
          }}
        >
          How did you get my Info?
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R13);
          }}
        >
          DNC
        </button>
        <button
          className="right-button"
          onClick={() => {
            PlayAudio(M3);
          }}
        >
          Weather
        </button>

        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R19);
          }}
        >
          Email
        </button>

        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R17);
          }}
        >
          Affordability Issue
        </button>

        <button
          className="right-button"
          onClick={() => {
            PlayAudio(R20);
          }}
        >
          Called Before
        </button>
      </div>
    </div>
  );
};

export default Avatar;
